<footer class="sidebar-user-footer user-section bg-white px-3 py-3 d-flex flex-column align-items-stretch gap-2 border-top border-danger-subtle">

  <PlatformSwitcher />

  <router-link
    v-if="is_admin"
    to="/user_management"
    class="sidebar-user-management-link d-flex align-items-center text-decoration-none w-100 rounded-3 px-2 py-2"
    aria-label="Open user management"
    data-tooltip="User Management"
  >
    <i class="bi bi-people-fill sidebar-user-management-icon me-2"></i>

    <span class="sidebar-user-management-text sidebar-menu-text text-muted fw-semibold text-xs">
      User Management
    </span>
  </router-link>

  <router-link
    to="/profile"
    class="sidebar-profile-link d-flex align-items-center text-decoration-none w-100 rounded-3 px-2 py-2"
    aria-label="Open profile"
    data-tooltip="Profile"
  >
    <div class="user-avatar rounded-circle me-2 d-flex justify-content-center align-items-center text-white fw-light avatar-size">
      {{ initials }}
    </div>

    <div class="sidebar-user-name flex-grow-1 min-w-0">
      <p class="sidebar-user-name-text text-dark fw-bold text-xs mb-0">{{ full_name }}</p>
    </div>
  </router-link>

</footer>
